<template>
<div>
  <div>
    <loader v-model=status.loading></loader>
    <arksnackbar v-model="status"></arksnackbar>
    <kalem v-model="dialogData"></kalem>
    <adresaradialog v-model="adresDialogData"></adresaradialog>
    <confirm ref="confirm"></confirm>
    <profildialog ref="profildialog"></profildialog>
    <fatura ref="fatura"></fatura>

  </div>

  <v-stepper v-model="e1" :input="stepperShow()" non-linear>
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" :step=step.onKayit editable>Ön Kayıt Bilgileri -1</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 2" :step=step.kisiBilgileri editable>Kişi Bilgileri -2</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 3" :step=step.rezKalemleri editable>Rez. Kalemleri -3</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 4" :step=step.tahsilat editable>Tahsilat -4</v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step :step=step.dokumanlar editable>Dökümanlar -5</v-stepper-step>

    </v-stepper-header>

    <v-stepper-items>

      <!--1 Ön Kayıt Bilgileri *************************************************************************-->
      <v-stepper-content :step=step.onKayit>
        <v-form ref="formOnKayit" v-model="valid" lazy-validation>
          <v-card color="grey lighten-1">

            <!--<v-container grid-list-xs>-->
            <v-layout row="" wrap="">
              <div class="flex sm6">
                <!--<arkprogress v-model="status.loading"></arkprogress>-->
                <pnrara hide-details v-model="Rez.pNR_No" v-on:kodonchange="pnrchange"> </pnrara>

                <genelarama apiname="CariAra" label="Cari :" v-model="Rez.cariKod" required :rules="[v => !!v.id || 'Kod boş geçilemez.', v => v.id != '0' || 'Kod tanımlanmamış.']"></genelarama>
                <v-text-field hide-details label="Rezervasyon Veren" v-model="Rez.rezVeren"></v-text-field>
                <genelarama apiname="MasrafMerkeziAra" label="Masraf Merkezi :" v-model="Rez.masrafMerkezi"></genelarama>

                <anatip v-model="Rez.anaTip"></anatip>
                <v-text-field hide-details label="Kayıt Tarihi" type="date" v-model="Rez.kayitTarihi"></v-text-field>
              </div>
              <div class="flex sm6">
                <v-text-field hide-details label="Ülke" v-model="Rez.ulke"></v-text-field>
                <v-text-field hide-details label="Karşı Rezervasyon Kodu" v-model="Rez.karsiRezKod"></v-text-field>
                <v-text-field hide-details label="Tur Kodu" v-model="Rez.turKod"></v-text-field>
                <geneltipara tip="AcenteDepartman" v-model="Rez.acenteDepartman"></geneltipara>
                <v-text-field hide-details label="Bölüm / Hizmet No" v-model="Rez.hizmetNo"></v-text-field>
                <v-text-field hide-details label="Referans" v-model="Rez.referansKod"></v-text-field>
              </div>
            </v-layout>
            <!--</v-container>-->

          </v-card>
        </v-form>

        <v-btn color="primary" @click.native="YeniPNR()">YENİ</v-btn>
        <v-btn color="primary" @click.native="SonrakiSayfa(step.onKayit)">İLERİ</v-btn>

      </v-stepper-content>

      <!--2 Kişi Bilgileri ****************************************************************************************-->
      <v-stepper-content :step=step.kisiBilgileri>
        <v-card color="grey lighten-1" class="mb-5">

          <v-layout row="" wrap="">

            <div class="flex sm6 lg3">
              <kisitip v-model="Adres.kisiTip"></kisitip>
              <v-text-field hide-details label="Yaş" v-model="Adres.yas"></v-text-field>
              <v-text-field hide-details label="TC Kimlik No" v-model="Adres.tcKimlikNo" v-on:change="tckn_change()"></v-text-field>
              <v-text-field hide-details label="Üye No" v-model="Adres.uyeNo"></v-text-field>
              <v-text-field hide-details label="Ad Soyad" v-model="Adres.adSoyad"></v-text-field>
              <v-textarea hide-details label="Adres" v-model="Adres.adres"></v-textarea>

            </div>
            <div class="flex sm6 lg3">
              <v-text-field hide-details type="date" label="Doğum Tarihi" v-model="Adres.dogumTarihi"></v-text-field>
              <v-text-field hide-details label="Cinsiyet" v-model="Adres.cinsiyet"></v-text-field>
              <v-text-field hide-details label="Telefon 1" v-model="Adres.telefon1"></v-text-field>
              <v-text-field hide-details label="Cep Telefonu" v-model="Adres.gsm"></v-text-field>
              <v-text-field hide-details label="E Mail" v-model="Adres.eMail"></v-text-field>
              
            </div>

            <!-- Begin Data Table ************************************************************************************-->
            <div class="flex sm12 lg6">
              <v-btn small @click="KisiEkle()">Ekle</v-btn>
              <v-btn small @click="KisiAra()">Kisi Ara</v-btn>

              <v-data-table :headers="yolcutableheaders" :items="Rez.adresler" hide-actions class="elevation-1">
                <template slot="items" slot-scope="props">
                  <tr @click="AdresSec(props.item)">
                    <td>{{ KisiTipToStr(props.item.kisiTip) }}</td>
                    <td>{{ props.item.adSoyad }}</td>
                    <td>{{ props.item.tcKimlikNo }}</td>
                    <td class="justify-center layout px-0">

                      <!--<v-btn icon class="mx-0" @click="adresEdit(props.item)">
                      <v-icon color="teal">edit</v-icon>
                    </v-btn> -->

                      <v-btn icon class="mx-0" @click="deleteAdres(props.item)">
                        <v-icon color="pink">delete</v-icon>
                      </v-btn>
                      <v-btn icon class="mx-0" @click="profil(props.item)">
                        p
                      </v-btn>

                    </td>

                  </tr>
                </template>
              </v-data-table>
            </div>
            <!-- End Data Table *************************************************************************************** -->

          </v-layout>

        </v-card>
        <v-btn color="primary" @click.native="OncekiSayfa(step.kisiBilgileri)">GERİ</v-btn>
        <v-btn color="primary" @click.native="SonrakiSayfa(step.kisiBilgileri)">İLERİ</v-btn>
      </v-stepper-content>

      <!--3 Rez Kalemleri ****************************************************************************************-->
      <v-stepper-content :step=step.rezKalemleri>
        <v-card color="grey lighten-1" class="mb-5">

          <v-btn small @click.native="kalemEkle('1')">Otel</v-btn>
          <v-btn small @click.native="kalemEkle('2')">Arac</v-btn>
          <v-btn small @click.native="kalemEkle('3')">Restaurant</v-btn>
          <v-btn small @click.native="kalemEkle('4')">Acente</v-btn>
          <v-btn small @click.native="kalemEkle('5')">RentACar</v-btn>
          <v-btn small @click.native="kalemEkle('6')">Rehber</v-btn>
          <v-btn small @click.native="kalemEkle('7')">Muze</v-btn>
          <v-btn small @click.native="kalemEkle('8')">Charter</v-btn>
          <v-btn small @click.native="kalemEkle('9')">Gemi</v-btn>
          <v-btn small @click.native="kalemEkle('10')">Diger</v-btn>
          <v-btn small @click.native="kalemEkle('11')">Vize</v-btn>
          <v-btn small @click.native="kalemEkle('14')">Sigorta</v-btn>
          <v-btn small @click.native="kalemEkle('15')">Feribot</v-btn>
          <v-btn small @click.native="kalemEkle('16')">Golf</v-btn>

          <!-- Begin Data Table ************************************************************************************-->
          <div class="flex md12">
            <v-data-table :headers="kalemtableheaders" :items="Rez.kalemler" hide-actions class="elevation-1">
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{ SaticiTipToStr(props.item.saticiTip) }}</td>
                  <td>{{ props.item.satici.isim}} - {{props.item.satici.kod}} - {{props.item.satici.id}}</td>
                  <td>{{ props.item.donem1 }}</td>
                  <td>{{ props.item.donem2 }}</td>
                  <td class="justify-center layout px-0">
                    <v-btn icon class="mx-0" @click="editKalem(props.item)">
                      <v-icon color="teal">edit</v-icon>
                    </v-btn>
                    <v-btn icon class="mx-0" @click="deleteKalem(props.item)">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <!-- End Data Table *************************************************************************************** -->

        </v-card>
        <v-btn color="primary" @click.native="OncekiSayfa(step.rezKalemleri)">GERİ</v-btn>
        <v-btn color="primary" @click.native="SonrakiSayfa(step.rezKalemleri)">KAYDET & İLERİ</v-btn>

      </v-stepper-content>

      <!--4 Tahsilat -->
      <v-stepper-content :step=step.tahsilat>
        <v-card color="grey lighten-1" class="mb-5">
          <odeme v-model="Rez"> </odeme>

        </v-card>
        <v-btn color="primary" @click.native="OncekiSayfa(step.tahsilat)">GERİ</v-btn>
        <v-btn color="primary" :loading="status.loading" @click.native="SonrakiSayfa(step.tahsilat)">İLERİ</v-btn>

      </v-stepper-content>

      <!--5 Dökümanlar ****************************************************************************************-->
      <v-stepper-content :step=step.dokumanlar>
        <v-card color="grey lighten-1" class="mb-5">

          <v-btn @click.native="faturaShow()">FATURA</v-btn>

        </v-card>
        <v-btn color="primary" @click.native="OncekiSayfa(step.dokumanlar)">GERİ</v-btn>
        <v-btn color="primary" @click.native="SonrakiSayfa(step.dokumanlar)">İLERİ</v-btn>

      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>

</div>
</template>

<script>
import pnrara from "@/components/app/coper/comp/pnrara.vue";
import cariara from "@/components/app/coper/comp/cariara.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import anatip from "@/components/app/coper/comp/anatip.vue";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import adresaradialog from "@/components/app/coper/comp/adresaradialog.vue";
import confirm from "@/components/app/coper/comp/confirm.vue";
import profildialog from "@/components/app/coper/comp/profildialog.vue";

import arkprogress from "@/components/app/coper/comp/arkprogress.vue";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import loader from "@/components/app/coper/comp/loader.vue";

import kisitip from "@/components/app/coper/comp/kisitip.vue";
import kalem from "@/components/app/coper/comp/kalem.vue";
import odeme from "@/components/app/coper/comp/odeme.vue";
import fatura from "@/components/app/coper/comp/fatura.vue";

import tool from "../../tools";
import rez from "../../rezervasyon";

export default {
  data() {
    return {
      e1: 0,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      valid: true,
      status: tool.NewSatatus(),
      step: {
        onKayit: 1,
        kisiBilgileri: 2,
        rezKalemleri: 3,
        tahsilat: 4,
        dokumanlar: 5
      },
      Rez: rez.Rezervasyon(),
      Adres: rez.Adres(),
      toplam: {
        satis: 0,
        alis: 0,
        komisyon: 0,
        iskonto: 0
      },

      dialogData: {
        dialogShow: false,
        kalem: rez.Kalem(),
        Rez: rez.Rezervasyon(),
        //satici:rez.Kalem().satici,
        adresler: [{
          Adres: rez.Adres()
        }]
      },
      adresDialogData: {
        dialogShow: false,
        adres: rez.Adres()
      },

      yolcutableheaders: [{
          text: "Kişi Tip",
          value: "kisiTip",
          sortable: false
        },
        {
          text: "Ad Soyad",
          value: "adSoyad",
          sortable: false
        },
        {
          text: "TC Kimlik No",
          value: "tcKimlikNo",
          sortable: false
        },
        {
          text: "İşlem",
          value: "name",
          sortable: false
        }
      ],
      kalemtableheaders: [{
          text: "Satici Tipi",
          value: "saticiTip"
        },
        {
          text: "Satıcı Kodu",
          value: "saticiKod"
        },
        {
          text: "Dönem 1",
          value: "denem1"
        },
        {
          text: "Dönem 2",
          value: "donem2"
        },
        {
          text: "İşlem",
          value: "name",
          sortable: false
        }
      ]
    };
  },
  components: {
    pnrara,
    cariara,
    genelarama,
    anatip,
    geneltipara,
    arkprogress,
    arksnackbar,
    kisitip,
    kalem,
    adresaradialog,
    confirm,
    profildialog,
    loader,
    odeme,
    fatura,
  },

  methods: {
    pnrchange: pnrchange,
    tckn_change: tckn_change,
    KisiEkle: KisiEkle,
    KisiAra: KisiAra,
    YeniPNR: YeniPNR,

    AdresSec: AdresSec,
    SonrakiSayfa: SonrakiSayfa,
    OncekiSayfa: OncekiSayfa,

    IsimBul: IsimBul,
    IsimSiraBul: IsimSiraBul,
    IsimIdBul: IsimIdBul,

    deleteAdres: deleteAdres,
    mesajGoster: mesajGoster,
    editKalem: editKalem,
    deleteKalem: deleteKalem,
    profil: profil,
    kalemEkle: kalemEkle,
    rezervasyonKaydet: rezervasyonKaydet,
    faturaShow: faturaShow,

    stepperShow() {
      if (this.e1 == this.step.tahsilat) {
        //console.log(v);
        //console.log(this.e1);

      }
    },

    KisiTipToStr(tip) {
      return rez.KisiTipToStr(tip);
    },
    SaticiTipToStr(tip) {
      return rez.SaticiTipToStr(tip);
    }
  }
};

function faturaShow() {
  this.$refs.fatura.open("", "").then(confirm => {
    if (confirm == true) {
      //this.Rez = rez.Rezervasyon();
      console.log('Fatura Ok');
    }else{
      console.log('Cancel');

    }
  });
}

function YeniPNR() {
  this.$refs.confirm.open("Temizle", "Form Temizlensin mi?").then(confirm => {
    if (confirm == true) {
      this.Rez = rez.Rezervasyon();
    }
  });
}

function deleteKalem(kalem) {
  this.$refs.confirm
    .open("Kalem Sil", "Kalem Silinsinmi ?", {
      color: "red"
    })
    .then(confirm => {
      if (confirm == true) {
        const index = this.Rez.kalemler.indexOf(kalem);
        this.Rez.kalemler.splice(index, 1);
      }
    });
}

function profil(kalem) {
  this.$refs.profildialog
    .open(kalem.profilId, {
      color: "red"
    })
    .then(profildialog => {
      if (profildialog.ok) {
        kalem.profilId = profildialog.id;
      }
    });
}

function editKalem(item) {
  this.dialogData.adresler = this.Rez.adresler;
  this.dialogData.Rez = this.Rez;
  this.dialogData.editedIndex = this.Rez.kalemler.indexOf(item);

  this.dialogData.kalem = JSON.parse(JSON.stringify(item));
  //this.dialogData.kalem = Object.assign({}, item);
  //this.dialogData.kalem.satisPara = Object.assign({}, item.satisPara);

  //this.dialogData.satici = Object.assign({}, item.satici);

  //this.dialogData.dialogShow = false;
  this.dialogData.dialogShow = true;
}

function kalemEkle(saticiTip) {
  var kalem = rez.Kalem();
  kalem.saticiTip = saticiTip;
  this.editKalem(kalem);
}

function mesajGoster(mesaj) {
  this.$refs.confirm.messageShow("Rezervasyon", mesaj);
}

function AdresSec(v) {
  this.Adres = Object.assign({}, v);
}

function SonrakiSayfa(v) {
  if (v == this.step.onKayit) {
    if (this.$refs.formOnKayit.validate()) {
      this.e1 = this.step.kisiBilgileri;
    }
  }
  if (v == this.step.kisiBilgileri) {
    if (this.Rez.adresler.length > 0) this.e1 = this.step.rezKalemleri;
    else this.mesajGoster("Lütfen listeye kişi ekleyiniz.");
  }
  if (v == this.step.rezKalemleri) {
    if (!this.$refs.formOnKayit.validate()) {
      this.e1 = this.step.onKayit;
    } else if (this.Rez.adresler.length == 0) {
      this.e1 = this.step.kisiBilgileri;
      this.mesajGoster("Lütfen listeye kişi ekleyiniz.");
    } else if (this.Rez.kalemler.length == 0) {
      this.e1 = this.step.rezKalemleri;
      this.mesajGoster("Lütfen listeye kalem ekleyiniz.");
    } else {
      this.rezervasyonKaydet(this.step.tahsilat);
    }
  }
  if (v == this.step.tahsilat) {
    this.e1 = this.step.dokumanlar;
  }
  if (v == this.step.dokumanlar) {
    this.e1 = this.step.onKayit;
  }
}

function OncekiSayfa(v) {
  if (v == this.step.onKayit) {
    this.e1 = this.e1;
  } else if (v == this.step.kisiBilgileri) {
    this.e1 = this.step.onKayit;
  } else if (v == this.step.rezKalemleri) {
    this.e1 = this.step.kisiBilgileri;
  } else if (v == this.step.tahsilat) {
    this.e1 = this.step.rezKalemleri;
  } else if (v == this.step.dokumanlar) {
    this.e1 = this.step.tahsilat;
  }
}

function pnrchange(v) {
  if (v != 0) {
    //console.log("pnrchange =" + this.Rez.pNR_No);

    this.status.loading = true;

    tool
      .http_post(this, "GetRezervasyon", {
        Id: this.Rez.pNR_No
      })
      .then(
        response => {
          if (response.body.pNR_No == 0) {
            this.Rez = rez.Rezervasyon();
            this.status.text = "PNR bulunamadı";
            this.status.show = true;
          } else {
            this.Rez = response.body;
            this.toplam = response.body.toplamTL;
            //this.status.text = "PNR bilgisi getirildi";
          }
          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
          this.Rez = rez.Rezervasyon();
        }
      );
  }
}

function tckn_change() {
  if (this.Adres.tcKimlikNo.length == 11) {
    this.status.loading = true;

    tool.http_post(this, "TblAdresTcknAra", this.Adres).then(
      response => {
        console.log("tckn_change v =" + this.Adres.tcKimlikNo);

        console.log(response.body);
        if (response.body != null) {
          this.Adres = response.body;
        }
        this.status.loading = false;
      },
      response => {
        this.status = tool.responseToStatus(response);
      }
    );
  }
}

function rezervasyonKaydet(sayfa) {
  this.status.loading = true;
  tool.http_post(this, "RezervasyonKaydet", this.Rez).then(
    response => {
      if (response.body.ok) {
        this.Rez = response.body.rezervasyon;
        this.toplam = response.body.rezervasyon.toplamTL;
        this.e1 = sayfa;

      } else {
        this.Rez = response.body.rezervasyon;
        this.status.text = response.body.hataList;
        this.status.show = true;

      }
      this.status.loading = false;
    },
    response => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function IsimSiraBul(adres) {
  return adres.kisiSira === this.Adres.kisiSira;
}

function IsimBul(adres) {
  return (
    adres.adSoyad === this.Adres.adSoyad &&
    adres.kisiSira !== this.Adres.kisiSira
  );
}

function IsimIdBul(adres) {
  return adres.id === this.Adres.id && adres.id > 0;
}

function KisiAra() {
  this.adresDialogData = {
    adres: this.Adres,
    dialogShow: true
  };
}

function KisiEkle() {
  var a = this.Rez.adresler.find(this.IsimSiraBul);
  var b = this.Rez.adresler.find(this.IsimBul);
  var c = this.Rez.adresler.find(this.IsimIdBul);

  if (this.Adres.adSoyad !== "") {
    if (c !== undefined) {
      var sira = c.kisiSira;
      this.Adres.kisiSira = sira;
      Object.assign(this.Rez.adresler[sira], this.Adres);
      this.Adres = rez.Adres();
    } else if (
      this.Rez.adresler.length == 0 ||
      (this.Adres.kisiSira == -1 && b == undefined)
    ) {
      this.Adres.kisiSira = this.Rez.adresler.length;
      this.Rez.adresler.push(Object.assign({}, this.Adres));
      this.Adres = rez.Adres();
    } else if (a !== undefined && b == undefined) {
      var sira = this.Adres.kisiSira;
      Object.assign(this.Rez.adresler[sira], this.Adres);
      this.Adres = rez.Adres();
    } else {
      this.mesajGoster("benzer isim girilemez");
    }
  } else {
    this.mesajGoster("İsim Girmelisiniz");
  }
}

function deleteAdres(adres) {
  this.$refs.confirm
    .open("Kişi Sil", "Kişi Silinsin mi?", {
      color: "red"
    })
    .then(confirm => {
      if (confirm == true) {
        var sira = adres.kisiSira;
        //console.log("deleteAdres sira:" + sira);
        //console.log(this.Rez.kalemler);

        var i = 0;
        var j = 0;
        var k = 0;

        this.Rez.adresler.splice(sira, 1);
        for (i = 0; i < this.Rez.adresler.length; i++) {
          if (sira < this.Rez.adresler[i].kisiSira) {
            this.Rez.adresler[i].kisiSira--;
          }
        }

        for (i = 0; i < this.Rez.kalemler.length; i++) {
          for (j = 0; j < this.Rez.kalemler[i].kisiSira.length; j++) {
            if (sira == this.Rez.kalemler[i].kisiSira[j]) {
              this.Rez.kalemler[i].kisiSira.splice(j, 1);
              break;
            }
          }
          for (k = 0; k < this.Rez.kalemler[i].kisiSira.length; k++) {
            if (sira < this.Rez.kalemler[i].kisiSira[k]) {
              this.Rez.kalemler[i].kisiSira[k]--;
            }
          }
        }
        this.Adres.kisiSira = -1;
      }
    });
}
</script>
